export default __webpack_public_path__ + "static/media/search.dcaa644d.svg";